import { Constants } from '../style/styleConstants'
import { useMinWidth } from './useMinWidth'

/**
 * True where overlays are drawn as centred modals rather than as full-window
 * drawers. Drives the choices CSS cannot make on its own: which chrome an
 * overlay mounts at all, and where a pinned row belongs in the DOM.
 */
export const useDesktopModal = (): boolean =>
    useMinWidth(Constants.EXPANDED_BREAKPOINT)
